import React from 'react';

export default function TopBar() {
  return (
    <div className="bg-gold text-dark text-center py-2.5 px-5 font-condensed font-bold text-[15px] tracking-wide">
      📞 Call or Text for a FREE Quote — <a href="tel:4433592010" className="text-dark no-underline font-black hover:opacity-80 transition-opacity">443-359-2010</a> — Fast Same-Day Service Available
    </div>
  );
}